// Terms & Privacy Policy Constants
export const CURRENT_TERMS_VERSION = "v1.0";
